<h1 mat-dialog-title class="pt-2 text-center"> Ajout d'un MPCA</h1>
<div mat-dialog-content class="p-0">
    <div class="container no-gutters">

        <div class="row m-0 ">
            <mat-form-field class="col">
                <mat-label>Nom</mat-label>
                <input matInput [(ngModel)]="Model.Name" placeholder="Nom" required>
            </mat-form-field>
        </div>
        <div class="row m-0">
            <mat-form-field class="col">
                <mat-label>Matériel Scola</mat-label>
                <mat-select placeholder="Matériel Scola" [(ngModel)]="Model.ScolaMaterial">
                    @for (scola of ScolaMaterialList; track scola) {
                    <mat-option [value]="scola">
                        {{ scola }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row m-0">
            <mat-form-field class="col">
                <mat-label>Etat de dégradation</mat-label>
                <mat-select placeholder="Etat de dégradation" [(ngModel)]="Model.DegradationLevel">
                    @for (d of DegradationLevelList; track d; let i = $index) {
                    <mat-option [value]="i + 1">
                        {{ d }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row m-1">
            <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
                Annuler
            </button>
            <button appPreventDoubleClick class="col ms-1" mat-raised-button color="primary" (throttledClick)="finish()" [disabled]="!canFinish()">
                Ajouter
            </button>
        </div>
    </div>
</div>